export { InstagramNoBorderIcon } from './components/InstagramNoBorderIcon';
export { TiktokNoBorderIcon } from './components/TiktokNoBorderIcon';
export { YoutubeNoBorderIcon } from './components/YoutubeNoBorderIcon';
export { FoamLogo } from './components/FoamLogo';
export { WhalarLogo } from './components/WhalarLogo';
export { InstagramColorIcon } from './components/InstagramColorIcon';
export { TiktokColorIcon } from './components/TiktokColorIcon';
export { YoutubeColorIcon } from './components/YoutubeColorIcon';
export { SnapchatColorIcon } from './components/SnapchatColorIcon';
export { GoogleIcon } from './components/GoogleIcon';
export { FacebookIcon } from './components/FacebookIcon';
export { MicrosoftIcon } from './components/MicrosoftIcon';
